import {useEffect, useState} from 'react';
import {config} from "../config/app-config";

const useAutocompleteItems = (accessToken, tournamentId, environment, mode) => {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!accessToken) return;
        if (mode !== 'tournaments' && !tournamentId) return;

        const apiUrl = mode === 'tournaments'
            ? `${config[environment].api}/tournaments`
            : `${config[environment].api}/tournaments/${tournamentId}/${mode}`;

        const controller = new AbortController();

        const fetchItems = async () => {
            try {
                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    },
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setItems(data);
            } catch (error) {
                if (error.name === 'AbortError') return;
                setError(error);
                console.error('Error fetching items:', error);
            }
        };

        fetchItems();

        return () => controller.abort();
    }, [accessToken, environment, mode, tournamentId]);

    return {items, error};
};

export default useAutocompleteItems;
